<template>
  <DetailContentsLayout :is-mobile="isMobile">
    <template v-slot:header>
      <PageBack
        background="primary"
        back-color="white"
        background-height="187px"
        @back="$emit('back')"
      >
        <div class="row justify-end full-width">
          <LeaseTermCompletion
            :current-month="budget.currentMonth"
            :term="budget.term"
            size="h6"
            current-month-color="primary-soft"
            term-color="white"
          />
        </div>
      </PageBack>
    </template>

    <template v-slot:card>
      <LeaseSelectBudget
        class="q-mb-md"
        :leases="leases"
        :lease="selectedLease"
        :loading="leasesLoading"
        :disable="leasesLoading"
        @input="$emit('select:lease', $event)"
      />

      <BudgetSummaryCard
        :width="isMobile ? undefined : '360px'"
        :actual="budget.totalActual"
        :budget="budget.totalBudget"
        :variance="budget.totalVariance"
        :loading="loading"
      />
    </template>

    <template v-slot:details>
      <div
        class="row q-py-xl justify-center items-center full-height"
        v-if="loading && !isMobile"
      >
        <SAISpinner />
      </div>

      <div v-if="!loading && hasLeases && category">
        <BtnBack
          class="q-mt-lg q-mb-md"
          label="Back to budget items"
          @click="$emit('hide:budget-detail')"
        />
        <router-view />
      </div>

      <div v-if="!loading && displayStatements">
        <BtnBack
          class="q-mt-lg q-mb-md"
          label="Back to budget items"
          @click="$emit('hide:statement-documents')"
        />
        <BudgetStatements
          :statement-documents="budget.statementDocuments"
          :is-mobile="isMobile"
        />
      </div>

      <div v-if="!loading && !displayStatements && !category">
        <h4 class="text-weight-medium text-grey-10 q-mt-lg q-mb-xs">
          Lease to Date Running Cost budgets*
        </h4>
        <span class="text-tab text-weight-medium">
          *Does not include finance component
        </span>

        <BudgetTable
          class="q-mt-md"
          :items="budgetItems"
          @open:budget="$emit('open:budget', $event)"
        />

        <div class="row" v-if="hasStatements">
          <DocumentBtn
            :class="{ 'col-12': isMobile }"
            icon-color="grey-8"
            icon-size="sm"
            label="View Statements"
            @click="$emit('open:statement-documents')"
          />
        </div>
      </div>
    </template>
  </DetailContentsLayout>
</template>

<script>
import { SAISpinner } from 'ecx.saigon.ui.common';

export default {
  name: 'BudgetSummary',
  props: {
    isMobile: Boolean,
    loading: Boolean,
    budget: {
      type: Object,
      default: () => ({})
    },
    category: String,
    budgetItems: {
      type: Array,
      default: () => []
    },
    hasStatements: Boolean,
    displayStatements: Boolean,
    hasLeases: Boolean,
    selectedLease: {
      type: Object,
      default: () => ({})
    },
    leases: {
      type: Array,
      default: () => []
    },
    leasesLoading: Boolean
  },
  components: {
    SAISpinner,
    DetailContentsLayout: () => import('../../layouts/detail-contents-layout'),
    PageBack: () => import('../../molecule/page-back'),
    BudgetSummaryCard: () => import('../../organism/budget-summary-card'),
    LeaseTermCompletion: () => import('../../molecule/lease-term-completion'),
    BudgetTable: () => import('../../molecule/budget-table'),
    DocumentBtn: () => import('../../atom/document-btn'),
    BudgetStatements: () => import('../../molecule/budget-statements'),
    BtnBack: () => import('../../atom/btn-back'),
    LeaseSelectBudget: () => import('../../atom/lease-select-budget')
  }
};
</script>
